// extracted by mini-css-extract-plugin
module.exports = {"picture":"_3kAiSz0GcnJ7dZXOfcLSBx","picture_fallback":"GUSqsfU44ecTA4mpKL-x1"};